"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.date = exports.object = exports.array = exports.nullable = exports.primitive = void 0;
const primitive = (v) => v;
exports.primitive = primitive;
const nullable = (encode) => (v) => {
    return v != null ? encode(v) : null;
};
exports.nullable = nullable;
const array = (encode) => (v) => {
    return v.map(encode);
};
exports.array = array;
const object = (value) => {
    return value;
};
exports.object = object;
const date = (d) => d.toISOString();
exports.date = date;
//# sourceMappingURL=encode.js.map